import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMoreHoriz = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-273.78 -348.44 1955.56 2488.89",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		transform: "matrix(1 0 0 -1 0 1536)",
		d: "M384 800V608Q384 568 356.0 540.0Q328 512 288 512H96Q56 512 28.0 540.0Q0 568 0 608V800Q0 840 28.0 868.0Q56 896 96 896H288Q328 896 356.0 868.0Q384 840 384 800ZM896 800V608Q896 568 868.0 540.0Q840 512 800 512H608Q568 512 540.0 540.0Q512 568 512 608V800Q512 840 540.0 868.0Q568 896 608 896H800Q840 896 868.0 868.0Q896 840 896 800ZM1408 800V608Q1408 568 1380.0 540.0Q1352 512 1312 512H1120Q1080 512 1052.0 540.0Q1024 568 1024 608V800Q1024 840 1052.0 868.0Q1080 896 1120 896H1312Q1352 896 1380.0 868.0Q1408 840 1408 800Z"
	})
});
export default SvgMoreHoriz;
